import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastService } from 'thkee-common';

@Component({
  selector: 'app-common-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: true,
  imports: [NgIf, AngularSvgIconModule, NgClass],
})
export class ToastComponent {
  @Input() title?: string | boolean = '';
  @Input() isOpened: boolean = false;
  @Input() customClass: string = '';
  @Input() type?: 'message' | 'error' | 'info' | 'warning' = 'message';
  @Input() closeTimer: number = 15000;
  @Input() message: string = '';
  @Output() closeToast = new EventEmitter();

  constructor(private toastService: ToastService) {}

  open() {
    this.isOpened = true;
    setTimeout(() => {
      this.discard();
    }, this.closeTimer);
  }

  discard() {
    this.isOpened = false;
    this.closeToast.emit();
  }
}
